

import { useState, useEffect, useCallback } from "react";
import { obterHistoricoParticipantes } from "../services/participante.service";

export function useHistoricoParticipantes(projectId?: string) {
  const [participantes, setParticipantes] = useState<string[]>([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const buscarHistorico = useCallback(async () => {
    try {
      setCarregando(true);
      setErro(null);
      const historico = await obterHistoricoParticipantes(projectId);
      setParticipantes(historico);
    } catch (error) {
      console.error('[Hook] ❌ Erro ao carregar histórico:', error);
      setErro("Erro ao carregar histórico de participantes");
      setParticipantes([]);
    } finally {
      setCarregando(false);
    }
  }, []);


  useEffect(() => {
    buscarHistorico();
  }, [buscarHistorico, projectId]);


  const recarregar = useCallback(() => {
    buscarHistorico();
  }, [buscarHistorico]);

  return {
    participantes,
    carregando,
    erro,
    recarregar,
  };
}
